var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"keyboard-wrapper",class:{ 'has-keyboard': _vm.showKeyboard }},[_vm._t("default"),_c('transition',{attrs:{"name":"float"}},[(_vm.showKeyboard)?_c('Keyboard'):_vm._e()],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }